import React, { FC, useEffect, useRef, useState } from "react";
import { DEMO_EXPERIENCES_LISTINGS } from "data/listings";
import { ExperiencesDataType, StayDataType } from "data/types";
import Pagination from "shared/Pagination/Pagination";
import TabFilters from "./TabFilters";
import Heading2 from "components/Heading/Heading2";
import ExperiencesCard from "./ExperiencesCard";
import { requestAPI } from "utils/api";
import LOGOimg from "assets/logo/allta.png";
import AlltaInfo from '../../assets/logo/allta_intro.png';

// import Banner01 from '../../assets/banner/home_eventBanner_1.jpg';
// import Banner02 from '../../assets/banner/home_eventBanner_2.jpg';

// import Banner01 from '../../assets/banner/home_banner_01.jpg';
// import Banner02 from '../../assets/banner/home_banner_02.jpg';
// import Banner03 from '../../assets/banner/home_banner_03.jpg';
// import Banner04 from '../../assets/banner/home_banner_04.jpg';
// import Banner05 from '../../assets/banner/home_banner_05.jpg';

import { productType } from "types/productType";
import { productCategory } from "types/productCategory";
import { Link, Navigate } from "react-router-dom";

import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import "@egjs/react-flicking/dist/flicking-inline.css";
import FloattingButtons from "components_custom/FloattingButtons/FloattingButtons";

export interface SectionGridFilterCardProps {
	className?: string;
	data?: StayDataType[];
}

const DEMO_DATA: ExperiencesDataType[] = DEMO_EXPERIENCES_LISTINGS.filter(
	(_, i) => i < 8
);

const HomeGridFilterCard: FC<SectionGridFilterCardProps> = ({
	className = "",
	data = DEMO_DATA,
}) => {

	const theFlicking = useRef <Flicking>(null)

	const tabs: any = productType;
	const [tabActive, setTabActive] = useState<any>(productType[0]);


	const tabs2: any = productCategory;
	const [tabActive2, setTabActive2] = useState<any>(productCategory[0]);


	const [datas, setDatas] = useState<any>({
		oList: [],
		list: []
	});

	const [banners, setBanners] = useState<any[]>([]);
	const [autoPlayEnabled, setAutoPlayEnabled] = useState(true);
	let autoPlayTimeoutId: NodeJS.Timeout | null = null;

	useEffect(() => {
		(async () => {
			const bannerRes: any = await requestAPI('GET', `v1/banner`, null);
			if (bannerRes.code === 1000) {
				setBanners(bannerRes.data.list);
			}
		})();
	}, []);

	useEffect(() => {
		(async () => {
			const res: any = await requestAPI('GET', `v1/product`, null);

			//setList(res.data.list);
			const _datas = {
				oList: res.data.list,
				list: res.data.list,
			};

			//console.log('r33', res.data.list)

			setDatas(_datas);

			//updateData(res.data.list);
		})();
	}, [])

	useEffect(() => {
		let autoPlayInterval: NodeJS.Timeout | null = null;

		if (autoPlayEnabled && banners.length > 1) {
			autoPlayInterval = setInterval(() => {
				if (theFlicking.current && !theFlicking.current.animating) {
					theFlicking.current.next();
				}
			}, 3000);
		}

		return () => {
			if (autoPlayInterval) {
				clearInterval(autoPlayInterval);
			}
		};
	}, [autoPlayEnabled, banners]);

	const updateData = (_data: any) => {

		const _datas: any = { ..._data };

		let newDatas = [];

		newDatas = fillterTab(_datas.oList, "type", tabActive.key);
		//newDatas = fillterTab(newDatas, "category", tabActive2.key);

		_datas.list = newDatas;

		setDatas(_datas);
	};

	const fillterTab = (_datas: any, key: string, value: string) => {

		let v: any = [];

		if (value === "all") {
			v = [..._datas];
		} else {
			_datas.forEach((item: any) => {

				if (item[key] === value) {
					v.push(item);
				}
			});
		}

		return v;
	}

	const pauseAutoPlay = () => {
		setAutoPlayEnabled(false);
		if (autoPlayTimeoutId) {
			clearTimeout(autoPlayTimeoutId);
		}
		// 5초 후에 자동 롤링 다시 시작
		autoPlayTimeoutId = setTimeout(() => {
			setAutoPlayEnabled(true);
		}, 5000);
	};

	useEffect(() => {
		updateData(datas);
	}, [tabActive, tabActive2]);

	const renderTab = () => {
		return (
			<ul
				// className="ml-2 sm:ml-6 md:ml-12 flex space-x-5 sm:space-x-8 lg:space-x-11 overflow-x-auto hiddenScrollbar"
				className="grid grid-cols-3 rounded-full p-1 text-center text-md font-semibold leading-5 ring-1 ring-inset ring-gray-200 text-white"
			>
				{/* {tabs.map((tab: any, idx: number) => {
			
			const active = tab.key === tabActive.key;
			return (
				<li
					key={`tab_${idx}`}
					onClick={() => setTabActive(tab)}
					className={`cursor-pointer rounded-full gap-x-1 px-2.5 py-1 text-gray-500 ${
				  		active
						? "bg-red-600 text-white"
						: ""
					} `}

				>
					<span>🛵 {tab.label}</span>
			  	</li>
			);
		  })} */}

				<li
					onClick={() => setTabActive({ key: "all", label: "전체" })}
					className={`cursor-pointer rounded-full gap-x-1 px-2.5 py-1 text-gray-500 ${tabActive.key === "all"
							? "bg-black text-white"
							: ""
						} `}

				>
					<span>🅰️ 전체</span>
				</li>
				<li
					onClick={() => setTabActive({ key: "riding", label: "라이딩" })}
					className={`cursor-pointer rounded-full gap-x-1 px-2.5 py-1 text-gray-500 ${tabActive.key === "riding"
							? "bg-black text-white"
							: ""
						} `}

				>
					<span>🏍️ 라이딩</span>
				</li>
				<li
					onClick={() => setTabActive({ key: "driving", label: "드라이빙" })}
					className={`cursor-pointer rounded-full gap-x-1 px-2.5 py-1 text-gray-500 ${tabActive.key === "driving"
							? "bg-black text-white"
							: ""
						} `}

				>
					<span>🚙 드라이빙</span>
				</li>
			</ul>
		);
	};

	const renderTab2 = () => {
		return (
			<ul
				// className="ml-2 sm:ml-6 md:ml-12 flex space-x-5 sm:space-x-8 lg:space-x-11 overflow-x-auto hiddenScrollbar"
				className="grid grid-cols-4 text-center text-[0.9rem] font-bold leading-5 text-white"
			>
				{tabs2.map((tab: any, idx: number) => {

					const active = tab.key === tabActive2.key;
					return (
						<li
							key={`tab2_${idx}`}
							onClick={() => setTabActive2(tab)}
							className={`cursor-pointer rounded-full mr-3 px-3 py-1.5 text-gray-500 ${active
									? "bg-red-700 text-white"
									: "ring-1 ring-inset ring-gray-200"
								} `}
						>
							<span>{tab.label}</span>
						</li>
					);
				})}
			</ul>
		);
	};


	const renderTab3 = () => {
		
		const handleSortRegion = async (item: any) => {
			let res: any = null;
			if (item.key === "G1") {
				res = await requestAPI('GET', `v1/product`, null);
			} else {
				res = await requestAPI('GET', `v1/product/cateogory/${item.key}/test`, null);
			}

			//setList(res.data.list);
			const _datas = {
				oList: res.data.list,
				list: res.data.list,
			};

			setDatas(_datas);
			setTabActive2(item)
		};

		return (
			<div id="area_regionlist" className="">
				<div className="mx-auto max-w-2xl lg:mx-0">
					<p className="mt-2 text-lg leading-8 text-black font-bold pl-2">
						MOTOR TOUR로 떠나는 전세계 여행
					</p>
				</div>
				<ul
					role="list"
					className="mx-auto mt-5 grid w-full gap-x-1 md:gap-x-4 gap-y-1 md:gap-y-4 text-center grid-cols-4 pl-6 pr-6"
				>
					{tabs2.map((item: any, index: number) => (
						<li key={`area_regionlist_${index}`}>
							<a onClick={e => handleSortRegion(item)}>
								<img
									alt={`${item.label} 여행 지역`}
									src={`${process.env.REACT_APP_SERVER_FILE}/img/global/${item.key}.png`}
									className={`${tabActive2.key === item.key ? "ring-2 ring-inset ring-black" : ""} mx-auto p-1`}
								/>
								<p className="text-black mt-1 text-[1.3rem]">{item.label}</p>
							</a>
						</li>
					))}
				</ul>
			</div>
		)
	}


	//if (datas.list.length === 0) return (<></>);

	const emptyList = () => {
		return (
			<main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
				<div className="text-center">
					<p className="text-base font-semibold text-indigo-600">안내</p>
					<h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">등록된 상품이 없어요!</h1>
					<p className="mt-6 text-base leading-7 text-gray-600">해당 카테고리에 상품이 곧 등록될 예정이에요</p>

				</div>
			</main>
		)
	}


	const handleBannerClick = (e: React.MouseEvent, path: string) => {
		// 드래그 중이 아닐 때만 링크 이동
		if (!theFlicking.current?.animating && !theFlicking.current?.holding) {
			window.location.href = path;
		}
	};

	const moveNext = () => {
		if (theFlicking.current && !theFlicking.current.animating) {
			pauseAutoPlay();
			theFlicking.current.next();
		}
	};
	
	const movePrev = () => {
		if (theFlicking.current && !theFlicking.current.animating) {
			pauseAutoPlay();
			theFlicking.current.prev();
		}
	};

	return (
		<div
			className={`nc-SectionGridFilterCard ${className} !p-0 !m-0`}
			data-nc-id="SectionGridFilterCard"
		>
			<div className="pt-[20px]" />

			{/* <div className={"w-full flex justify-center"}>
				<img className={"h-[100px]"} src={AlltaInfo} />
			</div> */}

			<div className="pt-[10px]" />

			{banners.length > 0 && (
			<div className="relative">
				{banners.length > 1 && (
				<button
					onClick={movePrev}
					className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 rounded-full p-2 shadow-md hover:bg-white"
				>
					<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
					</svg>
				</button>
				)}

				<Flicking
					ref={theFlicking}
					moveType="snap"
					panelsPerView={1}
					circular={banners.length > 1}
				>
					{banners.map((item:any, i:number) => (
						<div key={`weekly_best_${i}`} className='flex justify-center items-center bg-productbox border-solid border-4 border-white'>
							<div className="flex justify-between">
								<span className="relative inline-block">
									<div className="w-full rounded-full bg-white">
										<div
											onClick={(e) => handleBannerClick(e, item.path)}
											style={{ cursor: 'pointer' }}
										>
											<img
												src={`${process.env.REACT_APP_SERVER_FILE}/banner/${item.image}`}
												draggable="false"
												className="select-none"
											/>
										</div>
									</div>
								</span>
							</div>
						</div>
					))}
				</Flicking>

				{banners.length > 1 && (
				<button
					onClick={moveNext}
					className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 rounded-full p-2 shadow-md hover:bg-white"
				>
					<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m8.25 4.5 7.5 7.5-7.5 7.5" />
					</svg>
				</button>
				)}
			</div>
			)}

			<div className="pt-[20px]" />
			<div className="flex justify-start">
				{renderTab3()}
			</div>

			{/* <div className="pt-[20px]" />
			<div className="flex justify-start">
				{renderTab3()}
			</div>

			<div className="hidden pt-[30px] ml-4">
				<div className="mx-auto max-w-2xl lg:mx-0">
				<p className="mt-2 text-lg leading-8 text-red-700 font-bold">
					{tabActive2.label} ＞ {tabActive.label} 상품
				</p>
				</div>
			</div> */}


			<div className="pt-[20px]" />
			<div className="flex justify-center">
				{renderTab()}
			</div>


			{/* <div className="pt-[40px]" />
			<div className="flex justify-start pl-4">
				{renderTab2()}
			</div> */}




			<div className="pt-[5px]">
				{
					datas.list.length > 0
						?
						<div className="mt-[16px] grid grid-cols-2 gap-6 md:grid-cols-3 ml-4 mr-4">
							{datas.list.map((item: any) => (
								<ExperiencesCard
									key={item.no}
									data={item}
								/>
							))}
						</div>
						:
						emptyList()
				}
			</div>



			<div className="p-5 bg-gray-100 text-gray-600 text-sm font-normal mt-10">
				<div className="pb-[5px]" />
				<div className="text-gray-400 text-2xl font-semibold">
					<span>allta</span>
				</div>
				<div className="mt-[15px]">
					<span>(주)올타</span>
					<span className="ml-1 mr-1">|</span>
					<span>대표이사 : 정성아</span>

					<span className="ml-1 mr-1">|</span>
					<span>사업자 등록번호 : 544-88-03223</span>
					{/* <span className="ml-1 mr-1">|</span>
					<span>통신판매업신고 : 경기-00000호</span> */}
					<span className="ml-1 mr-1">|</span>
					<span>메일 : hello@alltacompany.co.kr</span>
				</div>
				<div>
					<span>관광사업자 등록번호 : 제2024-000017호</span>
					<span className="ml-1 mr-1">|</span>
					<span>주소 : 경기도 화성시 동탄신리천로 270, 4층 402-186호 (오산동)</span>
					<span className="ml-1 mr-1">|</span>
					<span>호스팅서비스 제공자 : (주) 올타</span>
				</div>
				<span>고객센터 : 070-8057-6837 (오전 9시 - 오후 6시)</span>

				<div className="flex space-x-3 mt-4 text-gray-700 text-[0.9rem] font-normal">
						<div>	
							<Link to={`/intro`}>
								<a
									className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
								>
									회사소개
								</a>
							</Link>
						</div>
						<div>	
							<Link to={`/privacy`}>
								<a
									className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									>
									회원약관
								</a>
							</Link>
						</div>

						<div>	
							<Link to={`/security`}>
								<a
									className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									>
									개인정보 보안 정책
								</a>
							</Link>
						</div>
						<div>	
							<a
								href="mailto:hello@alltacompany.co.kr"
								className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
							>
								광고 제휴 문의
							</a>
						</div>
				</div>
				<div className="mt-4 text-gray-600 text-sm font-normal">(주) 올타는 통신판매 중개자로서 통신판매의 당사자가 아니며 상품의 예약, 이용 및 환불 등과 관련한 의무와 책임은 각 판매자에게 있습니다.</div>
				<div className="mt-4 text-gray-600 text-sm font-normal">(주) 올타가 소유/운영/관리하는 웹사이트 및 앱 내의 상품/판매자/이벤트 정보, 디자인 및 화면의 구성, UI를 포함하여 일체의 콘텐츠에 대한 무단 복제, 배포, 방송 또는 전송, 스크래핑 등의 행위는 저작권법 및 콘텐츠산업 진흥법 등 관련 법령에 의하여 엄격히 금지됩니다.</div>
				<div className="mt-[20px]" />
				<hr />
				<div className="pb-[200px]" />
			</div>

			<FloattingButtons bottom={true}/>

		</div>
	);
};

export default HomeGridFilterCard;